import { Form, RHFTextField } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Form)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${(p) => p.theme.spacing(0.5)};
`;

export const Input = styled(RHFTextField)`
  width: 100%;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    border-radius: ${(p) => p.theme.spacing(0.5)};
    gap: 1;
    border: none;
  }
  fieldset {
    border-color: ${(p) => p.theme.palette.grey[300]};
  }
  input {
    background: ${(p) => p.theme.palette.common.white};
    font-size: ${(p) => p.theme.typography.caption.fontSize};
  }
`;
